export default "__VITE_ASSET__NGvXYPx1__"